import {Header} from "./Header";
import {useState} from "react";
import YouTubeVideoModal from "@/components/YouTubeVideoModal";

const OnboardingTutorials = () => {
	const videoData = [
		{
			img: "/videoTutorial_banner/start.png",
			title: "प्रारंभ",
			videoId: "jMJsgibhCPY"
		},
		{
			img: "/videoTutorial_banner/step1.png",
			title: "नोंदणी करा",
			videoId: "CLb00Z0mo7M"
		},
		{
			img: "/videoTutorial_banner/step2.png",
			title: "लॉगिन करा आणि प्रोफाइल अपडेट करा | शोध एक्सप्लोर करा",
			videoId: "VxPlAJDt4OY"
		},
		{
			img: "/videoTutorial_banner/step3.png",
			title: "कुलवृक्ष एक्सप्लोर आणि अपडेट करा",
			videoId: "HTkYS8O00Us"
		},
		{
			img: "/videoTutorial_banner/step4.png",
			title: "वेबसाइट एक्सप्लोर करा",
			videoId: "xqExYRL0k0o"
		},
	];

	const [isModalOpen, setModalOpen] = useState(false);

	const [selectedVideoData, setSelectedVideoData] = useState({
		title: "",
		videoId: "",
	});

	const handleTutorialClick = (tutorialData) => {
		setSelectedVideoData(tutorialData);
		setModalOpen(true);
	}

	const closeModal = () => {
		setModalOpen(false);
		setTimeout(() => {
			setSelectedVideoData({
				title: "",
				videoId: "",
			});
		}, 250);
	}

	return (
		<>
			<div className="w-full bg-white rounded-lg flex flex-col items-center justify-center">
				<Header/>
				<img
					src="/videoTutorial_banner/banner-video-tutorial.jpg"
					alt="Information Banner"
					className="w-full object-cover shadow-lg"
				/>

				<div className="my-32 max-w-[1300px] mx-auto px-4">
					<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 mt-10">
						{videoData.map((data, i) => (
							<button
								key={i}
								onClick={() => handleTutorialClick({
									title: data.title,
									videoId: data.videoId,
								})}
								className={"bg-gray-200 rounded-xl p-4 relative flex flex-col items-center"}
							>
								<img
									src={data.img}
									alt=""
									className="shadow-xl w-3/4 sm:w-2/3 md:w-full -mt-16"
								/>
								<h2 className="text-center font-bold text-lg sm:text-xl md:text-2xl my-6 text-red-600">
									{data.title}
								</h2>
							</button>
						))}
					</div>
				</div>
			</div>

			<YouTubeVideoModal
				isModalOpen={isModalOpen}
				closeModal={closeModal}
				youTubeVideoData={selectedVideoData}
			/>
		</>
	);
};

export default OnboardingTutorials;
